import { delay as sagaDelay }                       from 'redux-saga'
import { actionChannel, call, put, take }           from 'redux-saga/effects'
import { activateToast, changeToast, dismissToast } from '../ducks'
import config                                       from './saga-config'

const { defaultToastShowtime, toastQueueDelay, defaultErrorToastShowtime } = config

export interface ToastMeta {
  message: string
  delay?: number
  values?: object
  error?: boolean
  i18nPrefix?: string
  withoutI18nPrefix?: boolean
}

function * handleToastAction (
  { meta: { toast: { delay, ...rest } } }
    : { meta: { toast: ToastMeta } }
) {
  const toastShowTime = rest.error
    ? delay || defaultErrorToastShowtime
    : delay || defaultToastShowtime

  yield put(changeToast(rest))
  yield put(activateToast())
  yield sagaDelay(toastShowTime)
  yield put(dismissToast())
  yield sagaDelay(toastQueueDelay)
}

export default function * watchToastAction () {
  const toastChannel = yield actionChannel(({ meta }: any) => meta && meta.toast)
  while (true) {
    const action = yield take(toastChannel)
    yield call(handleToastAction, action)
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/toast.saga.ts